export const iconFontAwesomeUsersPeopleChild = (
	<i className="fa-solid fa-child"></i>
);
